import { ISearchRequestParams } from "./case-assignment.model";
import { AppealRecordDTO } from "./document-details.model";

export interface IDRCaseSearchRequestBody {
  courtCaseNumber: string;
  docTypeId?: string;

}
export interface IDRCaseDocument {
  courtCaseNumber: string;
  courtUnitId: number;
  courtUnitName: string;
  docId: string;
  docTypeId: number;
  docTypename: string;
  ctpId?: number;
  cptId?: number;
  receiptTypeId: number;
  receiptTypeName: string;
  restrictionId: number;
  partiesByPrtIdIssuedBy: string;
  partiesByPrtIdReallyIssuedBy: string;
  partyIdCharging: string;
  partiesByPrtIdIssuedByName: string;
  partiesByPrtIdReallyIssuedByName: string;
  partyIdChargingName: string;
  restrictionName: string;
  seqPerCasePh?: number;
  dateMailed?: string;
  dateReceived?: Date;
  numberOfCopies: number;
  entryCompleted?: string;
  totalCaseValue?: number;
  valid?: string;
  ccmId?: number;
  ccmDesc?: string;
  letterNumber?: string;
  casePhaseCasId?: number;
  casePhaseId?: number;
  appealCourtId?: number;
  appealCourtName?: string;
  ctpShortName: string;
  cptShortName: string;
  validString?: string;
  attachmentsData?: Attachment[];
  uploadDocTypename?: string;
  receivedDate?: string;
  uploadDocCasePhTypeId?: number;
  transType?: string;
  uploadDocTypeId?: number;
  uploadDateReceived?: string;
  comments: string;
  oldCaseNumber: string;
  suitNumber: string;
  internalDocument?: string;
  courtroomId?: number;
  feeAssesmentId?: number;
  courtType?: string;
  isTrackingNumber?: string;
  caseCategory: string;
  courtUnitShortName: string;
  hearingProcessDocTypeId?: number;
  hearingProcessCasePhTypeId?: number;
  hearingCourtUnitId: number;
  hearingCourtUnitName: string;
  docCategory?: string;
  resultString: string;
  rulingDocTypeId?: number;
  rulingCasePhTypeId?: number;
  casePhEvtSequence?: number;
  triggeredTaskId?: string;
  triggeredTaskDetails?: string;
  taskId?: number;
  feeAmount: number;
  page: number;
  govtPartyFlag: boolean;
  feeCompTypesId: number;
  feeCompTypesName?: string;
  paymentTypes?: string;
  pocFeePaymentFlag: boolean;
  feeAssesmentTaskFlag: boolean;
  noBriefsFlag: boolean;
  counselFlag: boolean;
  avoidFeeCheckFlag: boolean;
  filePath?: string;
  courtId: number;
  modifiedBy?: string;
  courtLevelName?: string;
  documentsGridAddMessage?: string;
  duplicateDocumentMessage?: string;
  feeComponentsData?: any[];
  chargeAgainstData?: any;
  chargeClaimsData?: any;
  docPartiesData?: DocParty[];
  eventsData?: EventData[];
  documentStatus?: string;
  motionDocumentStatus: string;
}
export enum Label {
  parties = 'Parties',
  upload = 'Upload Documents',
  attachments = 'Attachments',
  feeDetails = 'Fee Details',
  allDocuments = 'All Documents',
  partiesRepresented = 'Parties Represented',
  witness = 'Witnesses',
  groupParties = 'Group Parties'

}
export interface DocParty {
  partyId: string; // Unique identifier for the party
  partyName: string; // Name of the party
  partyRoleId: number; // Role ID of the party
  partyRoleName: string; // Name of the role
  timeCreated: string; // Time when the party was created
  termination: string; // Termination details
  transType?: string; // Optional transaction type
  representationData?: []; // Optional representation data
  witnessData: WitnessData[]; // List of witness data
  isEdit?: boolean;
}
export interface modifyDocPayLoad {
  courtUnitName: string;
  courtUnitId: string;
  appealCourtName: string;
  appealCourtId: string;
  ctpShortName: string;
  ctpId: string;
  docTypename: string;
  docTypeId: string;
  cptShortName: string;
  cptId: string;
  courtCaseNumber: string;
  casePhaseId: string;
  docId: string;
  casePhaseCasId: string;
  partiesByPrtIdReallyIssuedBy: string;
  partiesByPrtIdReallyIssuedByName: string;
  filedByPartyIdPartyType: string;
  partiesByPrtIdIssuedBy: string;
  partiesByPrtIdIssuedByName: string;
  appellentPartyIdPartyType: string;
  appGroupGovtFlag: string;
  partyIdCharging: string;
  partyIdChargingName: string;
  respondentFieldIdPartyType: string;
  respGroupGovtFlag: string;
  comments: string;
  isTrackingNumber: string;
  restrictionName: string;
  restrictionId: string;
  receiptTypeName: string;
  receiptTypeId: string;
  numberOfCopies: string;
  dateReceived: string;
  dateMailed: string;
  oldCaseNumber: string;
  suitNumber: string;
  triggeredTaskId: string;
  triggeredTaskDetails: string;
  cutId: string;
  hearingCourtUnitName: string;
  hearingCourtUnitId: string;
  transType: string;
  documentsGridAddMessage: string;
  uploadDateReceived: string;
  courtType: string;
  caseCategory: string;
  courtUnitShortName: string;
  appealRecordDto: AppealRecordDTO | null;

}

export interface WitnessData {
  witnessId: string;
  witnessName: string;
  witnessAddr: string | null;
  witnessContact: string | null;
  transType: string | null;
  auditMessage: string;
}
export interface Attachment {
  docName: string; // Name of the document
  timeCreated: string; // Timestamp of creation
  alfrescoUrl: string; // URL for accessing the document
  docVersion?: string; // Optional document version
  alfrescoDocId?: string; // Optional Alfresco document ID
  docUploadDateReceived?: string; // Optional upload date received
  docId?: string; // Optional document ID
  caseId?: string; // Optional case ID
  casePhaseId?: number; // Optional case phase ID
  no?: number; // Optional number
}
export interface EventData {
  eventId: string; // Unique identifier for the event
  description: string; // Description of the event
}
export interface IDRAttachment {
  docName: string;
  timeCreated: string;
  alfrescoUrl: string;
  docVersion: null;
  alfrescoDocId: null;
  docUploadDateReceived: string;
  docId: null;
  caseId: null;
  casePhaseId: null;
  no: number;
  auditMessage: string;
  showClosetask?: boolean
}
export interface IDRattachementParams {
  page?: number;
  start?: number;
  limit?: number;
  docId: string;
  casePhaseCasId: string;
}
export interface ListofFilesResponse {
  data: IDRlistOfFiles[]; // Array of documents
  totalCount: number; // Total number of documents
}
export interface IDRlistOfFiles {
  caseNumber: string | null; // The case number, which is nullable
  docId: string; // Unique identifier for the document
  docName: string; // Name of the document
  docTypeName: string; // Type name of the document
  docLocation: string; // Location or URL for the document
  docStatus: string; // Status of the document (e.g., VALID)
  uploadedDate: number; // Uploaded date as a timestamp
  caseCategory: string; // Case category (e.g., FI)
  docURL: string; // URL to access the document
  docVersion: string; // Version of the document
  auditMessage: string; // Audit message for the document
}
export interface IDRlistOfFilesParams {
  page?: number;
  start?: number;
  limit?: number;
  property: string;
  direction: string;
}
export interface IDRmotionCaseNumberParams {
  caseNumber: string;
  page?: number;
  start?: number;
  limit?: number;
  property: string;
  direction: string;
}
export interface IDRmotionCaseNumber {
  id: string;
  name: string;
  auditMessage: string;
}
export interface IDRPartiesDTO {
  prtType: string | null;
  idStructureType: string | null;
  idStructureTypeName: string | null;
  idStructureTypeValue: string | null;
  partiesId: string;
  partiesName: string | null;
  education: string | null;
  occupation: string | null;
  familyName: string | null;
  partiesFullName: string | null;
  father: string | null;
  mother: string | null;
  placeOfBirth: string | null;
  dateOfBirth: string | null;
  religion: string | null;
  gender: string | null;
  nationality: string | null;
  groupPartyId: string | null;
  groupPartyName: string | null;
  groupPartySurname: string | null;
  groupPartyFullName: string | null;
  partyTypeForGroupHead: string | null;
  groupPartyParentId: string | null;
  groupPartiesFullName: string | null;
  emailId: string | null;
  mobileNumber: string | null;
  partyStatus: string;
  addressesData: any | null;
  contactsData: any | null;
  previousNamesData: any | null;
  aliasesData: any | null;
  otherIdsData: any | null;
  parTypeMembshipsData: any | null;
  casPhPrtRolesData: any | null;
  groupPartyDetails: any | null;
  validationString: string | null;
  transType: string | null;
  existingParty: string | null;
  operationalCourtId: string | null;
  isCourtStaff: string | null;
  govtPartyInGroup: string | null;
  courtId: string | null;
  auditMessage: string;
}
export interface IDRCaseCommentsDTO {
  caseNumber: string; // Mandatory field
  dateOfFiling: string | null; // Nullable string
  documentTypeName: string | null; // Nullable string
  comments: string | null; // Nullable string
  auditMessage: string; // Mandatory field
}
export interface IDRPartyRepresentationDTO {
  partyId: string;
  partyName: string;
  partyIdFor: string | null;
  casePhasesCaseId: string | null;
  casePhasesId: string | null;
  docId: string | null;
  beginDate: number | null;
  endDate: number | null;
  transType: string | null;
  partyRoleId: string | null;
  partyRoleName: string | null;
  partyFullName: string;
  groupPartyId: string;
  groupPartyFlag: boolean | null;
  auditMessage: string;
  isEdit?: boolean | null;
}
export interface PrintReceiptData {
  id: number;
  courtCaseNumber: string;
  caseCategory: string;
  courtUnitShortName: string;
  cutId: number;
  docId: string;
  courtUnitId: number;
  courtUnitName: string;
  hearingCourtUnitId: number;
  hearingCourtUnitName: string;
  docTypeId: number;
  docTypename: string;
  ctpId: number;
  cptId: number;
  ctpShortName: string;
  cptShortName: string;
  receiptTypeId: number;
  receiptTypeName: string;
  restrictionId: number;
  partiesByPrtIdIssuedBy: string;
  partiesByPrtIdReallyIssuedBy: string;
  partyIdCharging: string;
  partiesByPrtIdIssuedByName: string;
  partiesByPrtIdReallyIssuedByName: string;
  partyIdChargingName: string;
  restrictionName: string;
  ccmId: string;
  ccmDesc: string;
  dateMailed: string | null;
  dateReceived: string | null;
  numberOfCopies: number;
  validString: string;
  oldCaseNumber: string;
  suitNumber: string;
  comments: string;
  transType: string;
  documentsGridAddMessage: string;
  uploadDocTypeId: number;
  uploadDocTypename: string;
  uploadDocCasePhTypeId: string;
  uploadDateReceived: string | null;
  noBriefsFlag: boolean;
  triggeredTaskId: string;
  triggeredTaskDetails: string;
  totalCaseValue: number;
  letterNumber: string;
  casePhaseCasId: number;
  casePhaseId: number;
  appealCourtId: number;
  appealCourtName: string;
  counselFlag: boolean;
  entryCompleted: boolean;
  valid: boolean;
}

export interface Payload {
  printReceiptData: PrintReceiptData;
}
export interface CaseDataPayload {
  id: number;
  courtCaseNumber: string;
  caseCategory: string;
  courtUnitShortName: string;
  cutId: number;
  docId: string;
  courtUnitId: number;
  courtUnitName: string;
  hearingCourtUnitId: number;
  hearingCourtUnitName: string;
  docTypeId: number;
  docTypename: string;
  ctpId: number;
  cptId: number;
  ctpShortName: string;
  cptShortName: string;
  receiptTypeId: number;
  receiptTypeName: string;
  restrictionId: number;
  partiesByPrtIdIssuedBy: string;
  partiesByPrtIdReallyIssuedBy: string;
  partyIdCharging: string;
  partiesByPrtIdIssuedByName: string;
  partiesByPrtIdReallyIssuedByName: string;
  partyIdChargingName: string;
  restrictionName: string;
  ccmId: string;
  ccmDesc: string;
  dateMailed: string | null;
  dateReceived: string | null;
  numberOfCopies: number;
  validString: string;
  oldCaseNumber: string;
  suitNumber: string;
  comments: string;
  transType: string;
  documentsGridAddMessage: string;
  uploadDocTypeId: number;
  uploadDocTypename: string;
  uploadDocCasePhTypeId: string;
  uploadDateReceived: string | null;
  noBriefsFlag: boolean;
  triggeredTaskId: string;
  triggeredTaskDetails: string;
  totalCaseValue: number;
  letterNumber: string;
  casePhaseCasId: number;
  casePhaseId: number;
  appealCourtId: number;
  appealCourtName: string;
  counselFlag: boolean;
  entryCompleted: boolean;
  valid: boolean;
  docPartiesData: DocPartyData[] | [];
  NoBriefsFlag: boolean;
}

export interface DocPartyData {
  partyId: string;
  partyName: string;
  partyRoleId: number;
  partyRoleName: string;
  timeCreated: string;
  A$T: string;
  termination: string;
  transType: string;
  representationData: RepresentationData[];
  groupPartiesData: any[]; // Update if groupPartiesData structure is known
  witnessData: WitnessData[]; // Update if witnessData structure is known
}

export interface RepresentationData {
  partyId: string;
  partyName: string;
  partyFullName: string;
  groupPartyId: string;
  beginDate: string;
  endDate: string;
  transType: string;
}

export interface PrintRecieptRequest {
  id: number;
  courtCaseNumber: string;
  caseCategory: string;
  courtUnitShortName: string;
  cutId: number;
  docId: string;
  courtUnitId: number;
  courtUnitName: string;
  hearingCourtUnitId: number;
  hearingCourtUnitName: string;
  docTypeId: number;
  docTypename: string;
  ctpId: number;
  cptId: number;
  ctpShortName: string;
  cptShortName: string;
  receiptTypeId: number;
  receiptTypeName: string;
  restrictionId: number;
  partiesByPrtIdIssuedBy: string;
  partiesByPrtIdReallyIssuedBy: string;
  partyIdCharging: string;
  partiesByPrtIdIssuedByName: string;
  partiesByPrtIdReallyIssuedByName: string;
  partyIdChargingName: string;
  restrictionName: string;
  ccmId: number;
  ccmDesc: string;
  dateMailed: string | null;
  dateReceived: string;
  numberOfCopies: number;
  validString: string;
  oldCaseNumber: string;
  suitNumber: string;
  comments: string;
  transType: string;
  documentsGridAddMessage: string;
  uploadDocTypeId: number;
  uploadDocTypename: string;
  uploadDocCasePhTypeId: number;
  uploadDateReceived: string | null;
  NoBriefsFlag: boolean;
  triggeredTaskId: string;
  triggeredTaskDetails: string;
  totalCaseValue: number;
  letterNumber: string;
  casePhaseCasId: number;
  casePhaseId: number;
  appealCourtId: number;
  appealCourtName: string;
  counselFlag: boolean;
  entryCompleted: string;
  valid?: string;
}
export interface DocType {
  docTypeId: number;
  docTypeName: string;
  ctpShortName: string | null;
  cptShortName: string | null;
  cptId: number | null;
  ctpId: number | null;
  transType: string | null;
  parentDocId: number | null;
  mandatory: boolean | null;
  checklistFlag: boolean | null;
  auditMessage: string;
}
export interface AdditionalSupremeCourtCaseData {
  filingCourt: string;
  caseType: string;
  suitNo: string;
  lowerCourtCaseNo: string;
  comment: string;
  courtOfAppeal: string;
  appealDivision: string;
  appealCaseNo: string;
  appealJudgmentDate: string;  // ISO date string (could use Date type if converted)
  noticeFiledDate: string;
  transmissionDate: string;
  appealServiceDate: string;
  supplementaryFiled: boolean;
  supplementaryFiledDate: string;
  trialCourt: string;
  trialCourtDivision: string;
  trialJudge: string;
  trialJudgmentDate: string;
  appellantServiceDate: string;
  suitReferenceKey: string;
  casereqId: string;
  caseId: string;
  createdByApp: string;
  createdAt: string;
  justiceIds: number[];
}


